export const SET_LOADING = "SET_LOADING";
export const SET_SUCCESS = "SET_SUCCESS";
export const SET_ERROR = "SET_ERROR";

export const SET_SECURITY_QUESTION_LOADING = "SET_SECURITY_QUESTION_LOADING";
export const SET_SECURITY_QUESTION = "SET_SECURITY_QUESTION";
export const FETCH_USER_SECURITY_SUCCESS = "FETCH_USER_SECURITY_SUCCESS";
